import { render, staticRenderFns } from "./BlogPostPage.vue?vue&type=template&id=b878d67e&"
import script from "./BlogPostPage.vue?vue&type=script&lang=js&"
export * from "./BlogPostPage.vue?vue&type=script&lang=js&"
import style0 from "./BlogPostPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports